import {keys, pick, omit, extend} from 'lodash';

const serviceCaches = {};
// 在lego-sdk里面要依赖这个变量，控制哪些属性显示或者隐藏
export const SERVICE_HASH = {
    custom: {
        appId: 'number',
        urlId: 'string' // 自定义服务还比较麻烦，要先获取serviceId，然后在获取serviceId下面的apiList，这个urlId对应的是proxyUrl字段
    },
    map: {
        appId: 'number',
        geotableId: 'number'
    },
    vote: {
        authKey: 'string',
        voteId: 'string'
    },
    schema: {
        authKey: 'string',
        sid: 'string'
    },
    lottery: {
        authKey: 'string',
        activityId: 'string'
    },
    weibo: {
        authKey: 'string',
        weiboId: 'string'
    },
    audio: {
        appId: 'number',
        urlId: 'string'
        // text: 'string' 这个是spec里面配置的, 不属于后端service里面的字段
    },
    ar: {}
};

export const SERVICE_CACHE = {
    set(service, api) {
        let serviceCacheValue = generateServiceCacheValue(service, api);
        let serviceSdkValue = serviceCacheValue.sdkValue;
        serviceCaches[this.getCacheKey(serviceSdkValue)] = serviceCacheValue;
        return serviceCacheValue;
    },
    get(sdkValueObj) {
        return serviceCaches[this.getCacheKey(sdkValueObj)];
    },
    getCacheKey(sdkValueObj) {
        return keys(sdkValueObj).sort().map(key => `${key}=${sdkValueObj[key]}`).join('&');
    }
};

/**
 * 获取服务的值
 *
 * @param {Object} service service数据
 * @param {Object} api 自定义api数据
 * @return {Object} 服务的value，字段与SERVICE_HASH对应
 */
export function getServiceSdkValue(service, api) {
    // appId位于service的一级属性里面，其他的位于serviceData里面
    let type = service.type.toLowerCase();
    let value = {};
    let args = SERVICE_HASH[type];
    if (args.appId) {
        value.appId = service.appId;
    }
    switch (type) {
        case 'custom': {
            value.urlId = api.proxyUrl;
            break;
        }
        default: {
            // 如果存在serviceData就从serviceData里面读取
            let serviceData = service.serviceData;
            // 不存在就从service里面读取
            if (!serviceData) {
                serviceData = service;
            }
            extend(value, pick(serviceData, keys(omit(args, 'appId'))));
        }
    }
    return value;
}

export function generateServiceCacheValue(service, api) {
    let data = {
        name: service.name,
        serviceId: service.id,
        sdkValue: getServiceSdkValue(service, api)
    };
    if (api && api.id) {
        data.apiId = api.id;
        data.name = api.name;
    }
    return data;
}
